import './index.css';

export default ({children}) => children;
